import { REGULATED_REGIONS, pushConsentUpdate, readConsentChoice } from '~/utils/consent'

/**
 * Google Consent Mode v2 — defaults MUST be queued before any Google tag runs.
 *
 * Ordering guarantees:
 * - `enforce: 'pre'` + the `00.` filename prefix run this before every other
 *   client plugin, including nuxt-gtag's (which queues its own dataLayer
 *   entries at plugin setup and loads gtag.js deferred).
 * - The GTM loader (public/external.js) fires 5s after DOMContentLoaded and
 *   reads the same window.dataLayer, so it also sees these defaults.
 *
 * Pattern per Google docs: a global 'granted' default first, then a
 * region-scoped 'denied' default for EEA/UK/CH — region-specific commands
 * take precedence over the global one.
 */
export default defineNuxtPlugin({
  name: 'consent-mode-defaults',
  enforce: 'pre',
  setup() {
    const w = window as any
    w.dataLayer = w.dataLayer || []
    function gtag(..._args: unknown[]) {
      // gtag snippets push the `arguments` object, not an array — keep identical.
      // eslint-disable-next-line prefer-rest-params
      w.dataLayer.push(arguments)
    }

    gtag('consent', 'default', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted',
    })
    gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
      wait_for_update: 500,
      region: REGULATED_REGIONS,
    })

    // Returning visitor with a stored choice: replay it immediately so tags
    // don't sit in the denied default waiting for the banner.
    const stored = readConsentChoice()
    if (stored) {
      pushConsentUpdate(stored)
    }
  },
})
